export const ContractTypeVI = {
    "contractSider": {
        "headingLabel": "Loại Hợp Đồng",
        "personnelProfile": "Hồ sơ nhân sự",
        "laborContract": "Hợp đồng lao động",
        "salaryLevel": "Ngạch lương"
    },
    "contractTitle": {
        "name": "Tên hợp đồng",
        "type": "Hình thức hợp đồng",
        "insurance": "Đóng bảo hiểm",
        "method": "Hình thức",
        "unit": "Đơn vị",
        "duration": "Thời hạn",
        "signer": "Người ký"
    },
    "infomation": {
        "title" : "Danh sách loại hợp đồng",
        "info": "Thông tin chung",
        "allowance": "Phụ cấp",
        "create": "Tạo mới",
        "update": "Cập nhật",
        "cancel": "Hủy"
    },
    "label": {
        "name": "Nhập tên hợp đồng",
        "duration": "Nhập thời hạn",
        "signer": "Người ký",
        "nameBenefit": "Tên phụ cấp",
        "money": "Số tiền phụ cấp"
    },
    "actionMenu": {
        "update": "Sửa loại hợp đồng",
        "delete": "Xóa loại hợp đồng",
        "create": "Thêm loại hợp đồng"
    },
    "messageContract" : {
        "update" : "Sửa loại hợp đồng thành công!",
        "add" : "Thêm loại hợp đồng thành công!",
        "delete" : "Xóa loại hợp đồng thành công!"
    }
}
